@if (hasActions) {
  @if (showAcceptReject) {
    <div class="investment-action-wrap icon-group">
      <app-button
        type="button"
        [btnClass]="'btn btn-danger btn-icon-square'"
        [iconClass]="'fas fa-times'"
        [ariaLabel]="rejectLabel"
        (clicked)="handleReject()"
      />
      <app-button
        type="button"
        [btnClass]="'btn btn-success btn-icon-square'"
        [iconClass]="'fas fa-check'"
        [ariaLabel]="acceptLabel"
        (clicked)="handleAccept()"
      />
    </div>
  } @else if (showApprove) {
    <div class="investment-action-wrap">
      <app-button
        type="button"
        [label]="approveLabel"
        [btnClass]="'btn btn-primary btn-sm d-flex align-items-center gap-2'"
        (clicked)="handleApprove()"
      />
    </div>
  } @else if (showPendingCountdown) {
    <div class="investment-action-wrap">
      <app-button
        type="button"
        [label]="pendingCountdownText"
        [btnClass]="'btn btn-secondary btn-sm d-flex align-items-center gap-2'"
        [disabled]="true"
      />
    </div>
  }
}
